/* Keep the native, keyboard-accessible contents list compact on small screens. */
(() => {
  const media = window.matchMedia('(max-width: 749px)');
  const sync = () => document.querySelectorAll('.mr-journal__contents').forEach((contents) => { contents.open = !media.matches; });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
  else sync();
  media.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', sync);
})();
